<template>
  <div class="flex flex-col items-start gap-2">
    <span
      v-if="label"
      class="text-[11px] text-surface-600 uppercase tracking-[0.1em] pl-1 font-medium"
      >{{ label }}</span
    >
    <div class="w-full flex flex-col gap-[2px]">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: false,
    default: undefined,
  },
})
</script>
